export default __webpack_public_path__ + "static/media/keto_breath.4f8870a8.jpg";